import useTypedTranslation from '@hooks/useTypedTranslation'
import { useStoreDays } from '@state/scans'
import { cx } from '@utils/cx'
import { formatObservationTime } from '@utils/dates'

/** The store's newest scan, whatever day is selected. */
function LastScanLine({ className }: { className?: string }) {
  const { t, i18n } = useTypedTranslation()
  const { data: days } = useStoreDays()

  const lastScan = days?.[0]?.scans[0]?.scanDate
  if (!lastScan) return null

  return (
    <p className={cx('text-xs whitespace-nowrap text-tertiary', className)} data-testid='last-scan-line'>
      {t('quickSelects.day.lastScan', { time: formatObservationTime(new Date(lastScan), i18n.language) })}
    </p>
  )
}

export default LastScanLine
